import { createAction } from '@reduxjs/toolkit';

import { KaomojiCategory } from './init-state';

export const fetchDefaultKaomojis = createAction('kaomojis/fetch');
export const defaultKaomojisFetched = createAction<{ categories: KaomojiCategory[] }>('kaomojis/fetched');

export const addCustomKaomoji = createAction<{ content: string }>('kaomojis/save');
export const removeCustomKaomoji = createAction<{ content: string }>('kaomojis/remove');
